/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/fragments/_fixtures_controller.js"
/*!**************************************************!*\
  !*** ./src/js/fragments/_fixtures_controller.js ***!
  \**************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var fixturesController = function fixturesController() {
  var roundsEl = document.querySelector(".fixtures-grid__rounds");
  if (!roundsEl) return;
  var roundOf32Btn = roundsEl.querySelector(".fixtures-grid__btn-round-of-32");
  var roundOf16Btn = roundsEl.querySelector(".fixtures-grid__btn-round-of-16");
  var quarterFinalBtn = roundsEl.querySelector(".fixtures-grid__btn-quarter-final");
  var semiFinalBtn = roundsEl.querySelector(".fixtures-grid__btn-semi-final");
  var finalBtn = roundsEl.querySelector(".fixtures-grid__btn-final");
  if (!roundOf32Btn || !roundOf16Btn || !quarterFinalBtn || !semiFinalBtn || !finalBtn) return;
  var brackets = document.querySelectorAll(".fixtures-grid__fixtures .fixtures-grid__bracket");
  var finals = document.querySelector(".fixtures-grid__fixtures .fixtures-grid__finals");
  if (!brackets.length || !finals) return;
  var roundOf32Cols = document.querySelectorAll(".fixtures-grid__fixtures .fixtures-grid__round-of-32");
  var roundOf16Cols = document.querySelectorAll(".fixtures-grid__fixtures .fixtures-grid__round-of-16");
  var quarterFinalCols = document.querySelectorAll(".fixtures-grid__fixtures .fixtures-grid__quarter-final");
  var semiFinalCols = document.querySelectorAll(".fixtures-grid__fixtures .fixtures-grid__semi-final");
  if (roundOf32Cols.length < 2 || roundOf16Cols.length < 2 || quarterFinalCols < 2 || semiFinalCols.length < 2) return;
  var mobileScreenWidth = 640;
  var buttons = [roundOf32Btn, roundOf16Btn, quarterFinalBtn, semiFinalBtn, finalBtn];
  var cols = [roundOf32Cols, roundOf16Cols, quarterFinalCols, semiFinalCols];
  var classActiveList = ["active-at-32", "active-at-16", "active-at-quarter", "active-at-semi", "active-at-finals"];
  buttons.forEach(function (trigger, index) {
    trigger.addEventListener("click", function () {
      if (window.innerWidth >= mobileScreenWidth) return;
      buttons.forEach(function (btn) {
        if (btn !== trigger) btn.classList.remove("active");else btn.classList.add("active");
      });
      cols.forEach(function (colPairs, colIndex) {
        if (colIndex < index) colPairs.forEach(function (col) {
          col.classList.add("deactive");
        });else colPairs.forEach(function (col) {
          col.classList.remove("deactive");
        });
        brackets.forEach(function (bracket, bracketIndex) {
          classActiveList.forEach(function (className) {
            bracket.classList.remove(className);
            if (bracketIndex == 0) finals.classList.remove(className);
          });
          bracket.classList.add(classActiveList[index]);
          if (bracketIndex == 0) finals.classList.add(classActiveList[index]);
        });
      });
    });
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (fixturesController);

/***/ },

/***/ "./src/js/fragments/_overview_popup.js"
/*!*********************************************!*\
  !*** ./src/js/fragments/_overview_popup.js ***!
  \*********************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var overviewPopupFeature = function overviewPopupFeature() {
  var trigger = document.querySelector("#geting_in_team");
  var popup = trigger.parentElement.querySelector(".overview-grid__info-popup");
  var html = document.querySelector("html");
  var header = document.querySelector("header");
  if (!trigger || !popup) return;
  var overlay = popup.querySelector(".overview-grid__info-popup-overlay");
  if (!overlay) return;
  trigger.addEventListener("click", function () {
    popup.classList.remove("hidden");
    window.scrollTo({
      top: 0,
      behavior: "auto"
    });
    if (html) {
      html.style.overflow = "hidden";
    }
    if (header) header.style.zIndex = "0";
  });
  overlay.addEventListener("click", function () {
    popup.classList.add("hidden");
    if (html) html.style.removeProperty("overflow");
    if (header) header.style.removeProperty("z-index");
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (overviewPopupFeature);

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Check if module exists (development only)
/******/ 		if (__webpack_modules__[moduleId] === undefined) {
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!*********************************!*\
  !*** ./src/js/pages/ranking.js ***!
  \*********************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _fragments_overview_popup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../fragments/_overview_popup */ "./src/js/fragments/_overview_popup.js");
/* harmony import */ var _fragments_fixtures_controller__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../fragments/_fixtures_controller */ "./src/js/fragments/_fixtures_controller.js");


document.addEventListener("DOMContentLoaded", function () {
  (0,_fragments_overview_popup__WEBPACK_IMPORTED_MODULE_0__["default"])();
  (0,_fragments_fixtures_controller__WEBPACK_IMPORTED_MODULE_1__["default"])();
});
})();

/******/ })()
;
//# sourceMappingURL=ranking.bundle.js.map